{
	"development" : {
		"adminUrl" : "http://localhost:1337"
	},

	"production" : {
		"adminUrl" : "https://admin.msp-miremont.fr"
	}
}